goog.module('yext.developerapps.olomenusyncing.init');
goog.module.declareLegacyNamespace();

const OloMenuSyncingAccountConfiguration = goog.require('yext.developerapps.olomenusyncing.OloMenuSyncingAccountConfiguration');

$(document).ready(function() {
  var initIdentifier = $('.js-olomenusyncing-init').data('jsinit');
  switch (initIdentifier) {
    case 'olo':
      new OloMenuSyncingAccountConfiguration();
      break;
  }
});

